.row {
  align-items: center;
  background-color: var(--color-grayscale-charleston);

  &[data-isHidden='true'] {
    *:not(button),
    *:hover:not(button),
    *:focus-visible:not(button) {
      color: var(--color-grayscale-trout);
    }
  }
}

.cover-wrapper {
  margin-inline-start: 0.3rem;
}

.custom-editable {
  height: 100%;
  display: flex;
  align-items: center;
}

/* Doubled class: this overrides Description, which still injects its own
   styles at runtime. styled(Description) guaranteed the override won; a
   single class would depend on stylesheet order. */
.custom-description.custom-description {
  height: fit-content;
  padding: 0;
  line-height: 2.24rem;
  overflow-y: auto;
  color: var(--color-grayscale-ghost);

  &::-webkit-scrollbar {
    display: none;
  }
}
